import { Col, Row } from "react-bootstrap";
import Javascript from "../../Assets/TechIcons/Javascript.svg";
import Typescript from "../../Assets/TechIcons/Typescript.svg";
import ReactIcon from "../../Assets/TechIcons/React.svg";
import Next from "../../Assets/TechIcons/Next.svg";
import Tailwind from "../../Assets/TechIcons/Tailwind.svg";
import Node from "../../Assets/TechIcons/Node.svg";
import SQL from "../../Assets/TechIcons/SQL.svg";
import Redis from "../../Assets/TechIcons/Redis.svg";
import Mongo from "../../Assets/TechIcons/Mongo.svg";
import AWS from "../../Assets/TechIcons/AWS.svg";
import Docker from "../../Assets/TechIcons/Docker.svg";
import Git from "../../Assets/TechIcons/Git.svg";
import Postman from "../../Assets/TechIcons/Postman.svg";
import Python from "../../Assets/TechIcons/Python.svg";

const skills = [
  { icon: ReactIcon, label: "React" },
  { icon: Next, label: "Next.js" },
  { icon: Typescript, label: "TypeScript" },
  { icon: Javascript, label: "JavaScript" },
  { icon: Tailwind, label: "Tailwind CSS" },
  { icon: Node, label: "Node.js" },
  { icon: SQL, label: "PostgreSQL" },
  { icon: Redis, label: "Redis" },
  { icon: Mongo, label: "MongoDB" },
  { icon: AWS, label: "AWS" },
  { icon: Docker, label: "Docker" },
  { icon: Git, label: "Git" },
  { icon: Postman, label: "REST APIs" },
  { icon: Python, label: "Python" },
];

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {skills.map((skill) => (
        <Col xs={4} md={2} className="tech-icons" key={skill.label}>
          <img src={skill.icon} alt={skill.label} className="tech-icon-images" />
          <div className="tech-icons-text">{skill.label}</div>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
